/* eslint-disable react/prop-types */
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button } from "@material-ui/core";
import ReactToPrint from "react-to-print";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";

const TCSPrintLabelPdfView = (props) => {
  const { handleClose, open } = props;
  const componentRef = useRef();
  // eslint-disable-next-line no-unused-vars
  const [numPages, setNumPages] = useState(null);
  const [summaryPDFFile, setSummaryPDFFile] = useState(
    `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${props.summaryPdfFile}`
  );

  // Set the number of pages when the document loads
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  // Update the PDF file URL when the component receives new props
  useEffect(() => {
    if (props.summaryPdfFile) {
      const imageUrl = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${props.summaryPdfFile}`;
      setSummaryPDFFile(imageUrl);
    }
  }, [props.summaryPdfFile]);

  return (
    <Fragment>
      <ControlledDialog
        isFullScreen={true}
        open={open}
        fullWidth
        handleClose={() => handleClose()}
        title={
          <Fragment>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >
              Delivery Partner Shipping Label
            </span>
          </Fragment>
        }
        content={
          <Fragment>
            <ReactToPrint
              onAfterPrint={() => props.handlePrint()}
              trigger={() => (
                <Button
                  id="btnShippingLabelPrint"
                  style={{
                    textTransform: "capitalize",
                    opacity: 0.8,
                    float: "right",
                    zIndex: 1000,
                  }}
                  color="primary"
                  variant="contained"
                >
                  Print
                </Button>
              )}
              content={() => componentRef.current}
              pageStyle={`
                @page { size: A4 portrait; margin: 0; overflow: hidden; } 
                body { margin: 0; padding: 0; overflow: hidden; } 
                div { margin: 0; padding: 0; overflow: hidden; }
              `}
            />
            <div
              ref={componentRef}
              style={{ overflow: "hidden", height: "100vh" }}
              className="print-only"
            >
              <Document
                file={summaryPDFFile}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={"Loading page…"}
              >
                {/* Render only the first page */}
                <Page key="page_1" scale={1.3} pageNumber={1} />
              </Document>
            </div>
            <div className="no-print">
              <Document file={summaryPDFFile}>
                {/* Render only the first page */}
                <Page key="page_1" scale={1.3} pageNumber={1} />
              </Document>
            </div>
          </Fragment>
        }
      />
    </Fragment>
  );
};

export default TCSPrintLabelPdfView;
